export default function SmallRowIcon() {
  return (
    <svg
      width='14'
      height='15'
      viewBox='0 0 14 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='shrink-0 size-3.5'
    >
      <mask
        id='mask0_small_row'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='14'
        height='15'
      >
        <rect width='14' height='15' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_small_row)'>
        <path
          d='M12.5903 3.65486C12.5903 3.32987 12.3269 3.06641 12.0019 3.06641H1.99811C1.67311 3.06641 1.40965 3.32987 1.40965 3.65486C1.40965 3.97986 1.67311 4.24332 1.99811 4.24332H12.0019C12.3269 4.24332 12.5903 3.97986 12.5903 3.65486Z'
          fill='currentColor'
        />
        <path
          d='M12.5903 6.00838C12.5903 5.68338 12.3269 5.41992 12.0019 5.41992H1.99811C1.67311 5.41992 1.40965 5.68338 1.40965 6.00838C1.40965 6.33338 1.67311 6.59684 1.99811 6.59684H12.0019C12.3269 6.59684 12.5903 6.33338 12.5903 6.00838Z'
          fill='currentColor'
        />
        <path
          d='M12.5903 8.3619C12.5903 8.0369 12.3269 7.77344 12.0019 7.77344H1.99811C1.67311 7.77344 1.40965 8.0369 1.40965 8.3619C1.40965 8.68689 1.67311 8.95035 1.99811 8.95035H12.0019C12.3269 8.95035 12.5903 8.68689 12.5903 8.3619Z'
          fill='currentColor'
        />
        <path
          d='M12.5903 10.7154C12.5903 10.3904 12.3269 10.127 12.0019 10.127H1.99811C1.67311 10.127 1.40965 10.3904 1.40965 10.7154C1.40965 11.0404 1.67311 11.3039 1.99811 11.3039H12.0019C12.3269 11.3039 12.5903 11.0404 12.5903 10.7154Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
}
